export default __webpack_public_path__ + "static/media/graffiti.e4b03e75.svg";